var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStarYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icStarYellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Club-profile",
    transform: "translate(-111.000000, -1012.000000)",
    fillRule: "nonzero",
    stroke: "#FFC107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-1.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 442.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(51.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pointed-star",
    transform: "translate(25.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8104974,7.60514508 C38.5895308,7.60514508 38.3549723,7.42589017 38.2865204,7.2050179 L36.1236874,0.208641431 C36.0552356,-0.0122826064 35.9447769,-0.0122826064 35.876325,0.208641431 L33.713886,7.2050179 C33.6454341,7.42594193 33.4108756,7.60514508 33.1899091,7.60514508 L26.1910743,7.60514508 C25.9701077,7.60514508 25.9356848,7.71581415 26.1145953,7.85257172 L31.7764517,12.1758605 C31.9553623,12.3126181 32.0450392,12.6024903 31.9765873,12.8234143 L29.8141975,19.8193767 C29.7457456,20.0403007 29.8354225,20.1088348 30.0143331,19.972129 L35.6761895,15.6488402 C35.8551,15.5120826 36.1449617,15.5120826 36.3238722,15.6488402 L41.9857286,19.9725431 C42.1646392,20.1093007 42.2543161,20.0407148 42.1858642,19.8197908 L40.0234252,12.8238284 C39.9549733,12.6029044 40.0446502,12.3130322 40.2235607,12.1762746 L45.8854171,7.85298582 C46.0643277,7.71622825 46.0299048,7.60555918 45.8089382,7.60555918 L38.8104974,7.60555918 L38.8104974,7.60514508 Z",
    id: "icStarYellow"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarYellow);
export default __webpack_public_path__ + "static/media/icStarYellow.c54064ff72c8bf922b3d04ff41cfacb4.svg";
export { ForwardRef as ReactComponent };